<mat-form-field class="w-100" [class.compact]="compact" floatLabel="always" subscriptSizing="dynamic">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-select
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="valueChange.emit($event)"
    [multiple]="multiple"
    aria-haspopup="dialog"
    role="listbox"
    saveInputValue="short"
  >
    @for (choice of choices; track choice.value) {
      <mat-option [value]="choice.value">{{ choice.label | translate }}</mat-option>
    }
  </mat-select>
</mat-form-field>